// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PayPalOnboard_onboardBtn__Oihzf {
  background-color: #0070ba;
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  width: 200px;
}
.PayPalOnboard_onboardBtn__Oihzf:hover:not(:disabled) {
  background-color: #005ea6;
}
.PayPalOnboard_onboardBtn__Oihzf:disabled {
  background-color: #9fbfdd;
  cursor: not-allowed;
}
.PayPalOnboard_onboardBtn__Oihzf.PayPalOnboard_loading__C1sCO {
  position: relative;
}

.PayPalOnboard_modalOverlay__rvUnH {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* Modal box */
.PayPalOnboard_modal__Nd5\\+l {
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.2);
  animation: PayPalOnboard_fadeIn__BX82u 0.3s ease;
}
.PayPalOnboard_modal__Nd5\\+l h3 {
  margin-bottom: 12px;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}
.PayPalOnboard_modal__Nd5\\+l p {
  margin-bottom: 20px;
  font-size: 15px;
  color: #555;
}
.PayPalOnboard_modal__Nd5\\+l p b {
  color: #0070ba;
}

/* Modal buttons */
.PayPalOnboard_modalActions__nsYGm {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.PayPalOnboard_modalActions__nsYGm button {
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s ease;
}
.PayPalOnboard_modalActions__nsYGm button:nth-child(1) {
  background: #28a745;
  color: #fff;
}
.PayPalOnboard_modalActions__nsYGm button:nth-child(1):hover {
  background: #218838;
}
.PayPalOnboard_modalActions__nsYGm button:nth-child(2) {
  background: #0070ba;
  color: #fff;
}
.PayPalOnboard_modalActions__nsYGm button:nth-child(2):hover {
  background: #005c99;
}
.PayPalOnboard_modalActions__nsYGm button:nth-child(3) {
  background: #e0e0e0;
  color: #333;
}
.PayPalOnboard_modalActions__nsYGm button:nth-child(3):hover {
  background: #c9c9c9;
}
.PayPalOnboard_modalActions__nsYGm button:disabled {
  background: #aaa;
  cursor: not-allowed;
}

/* Fade-in animation */
@keyframes PayPalOnboard_fadeIn__BX82u {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@media (max-width: 1400px) {
  .PayPalOnboard_onboardBtn__Oihzf {
    width: 200px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/PaypalOnboard/PayPalOnboard.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;EACA,YAAA;AACF;AACE;EACE,yBAAA;AACJ;AAEE;EACE,yBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,kBAAA;AADJ;;AAKA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAFF;;AAKA,cAAA;AACA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,yCAAA;EACA,gDAAA;AAFF;AAIE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAFJ;AAKE;EACE,mBAAA;EACA,eAAA;EACA,WAAA;AAHJ;AAKI;EACE,cAAA;AAHN;;AAQA,kBAAA;AACA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AALF;AAOE;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AALJ;AAOI;EACE,mBAAA;EACA,WAAA;AALN;AAOM;EACE,mBAAA;AALR;AASI;EACE,mBAAA;EACA,WAAA;AAPN;AASM;EACE,mBAAA;AAPR;AAWI;EACE,mBAAA;EACA,WAAA;AATN;AAWM;EACE,mBAAA;AATR;AAaI;EACE,gBAAA;EACA,mBAAA;AAXN;;AAgBA,sBAAA;AACA;EACE;IACE,UAAA;IACA,sBAAA;EAbF;EAeA;IACE,UAAA;IACA,mBAAA;EAbF;AACF;AAiBA;EACE;IACE,YAAA;EAfF;AACF","sourcesContent":[".onboardBtn {\n  background-color: #0070ba;\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: 4px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  width: 200px;\n\n  &:hover:not(:disabled) {\n    background-color: #005ea6;\n  }\n\n  &:disabled {\n    background-color: #9fbfdd;\n    cursor: not-allowed;\n  }\n\n  &.loading {\n    position: relative;\n  }\n}\n\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n/* Modal box */\n.modal {\n  background: #fff;\n  padding: 24px;\n  border-radius: 12px;\n  width: 400px;\n  max-width: 90%;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.2);\n  animation: fadeIn 0.3s ease;\n\n  h3 {\n    margin-bottom: 12px;\n    font-size: 20px;\n    font-weight: 600;\n    color: #333;\n  }\n\n  p {\n    margin-bottom: 20px;\n    font-size: 15px;\n    color: #555;\n\n    b {\n      color: #0070ba;\n    }\n  }\n}\n\n/* Modal buttons */\n.modalActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n\n  button {\n    padding: 10px 16px;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: background 0.2s ease;\n\n    &:nth-child(1) {\n      background: #28a745; // green\n      color: #fff;\n\n      &:hover {\n        background: #218838;\n      }\n    }\n\n    &:nth-child(2) {\n      background: #0070ba; // PayPal blue\n      color: #fff;\n\n      &:hover {\n        background: #005c99;\n      }\n    }\n\n    &:nth-child(3) {\n      background: #e0e0e0;\n      color: #333;\n\n      &:hover {\n        background: #c9c9c9;\n      }\n    }\n\n    &:disabled {\n      background: #aaa;\n      cursor: not-allowed;\n    }\n  }\n}\n\n/* Fade-in animation */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n\n@media (max-width: 1400px) {\n  .onboardBtn {\n    width: 200px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"onboardBtn": `PayPalOnboard_onboardBtn__Oihzf`,
	"loading": `PayPalOnboard_loading__C1sCO`,
	"modalOverlay": `PayPalOnboard_modalOverlay__rvUnH`,
	"modal": `PayPalOnboard_modal__Nd5+l`,
	"fadeIn": `PayPalOnboard_fadeIn__BX82u`,
	"modalActions": `PayPalOnboard_modalActions__nsYGm`
};
export default ___CSS_LOADER_EXPORT___;
